'use strict';

module.exports = require('./components/DocEditor/InputBlock').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/InputBlock.js
// module id = 1897
// module chunks = 0